import React from 'react';
import Svg, {Path} from 'react-native-svg';
import {Props} from '../../../shared/assets/SvgProps';

const StepperCompletionTickIcon = ({color = 'white'}: Props) => (
  <Svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none">
    <Path
      d="M13.3346 4L6.0013 11.3333L2.66797 8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default StepperCompletionTickIcon;
